import { getPaymentApi } from '../api/payment';

const eventOn = emitter => {
  emitter.promiseOn('getPayment', () => {
    return getPaymentApi();
  });
};

export default eventOn;
